import React, { useEffect, useRef } from "react";
import { Button } from "@progress/kendo-react-buttons";
import { Typography } from "@progress/kendo-react-common";
import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import {
  gstWOValueValidator,
  MobileNoValidator,
  requiredValidator,
} from "../../components/formFields/CommonValidator";
import ShadowCard from "../../components/common/ShadowCard";
import ButtonWithLoading from "../../components/common/ButtonWithLoading";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { LoadingPanel } from "../../components/layout/Loading";
import FormTextField from "../../components/formFields/FormTextField";
import {
  insertCompanyInfo,
  getRenewHistory,
  getCompanyDetails,
} from "./services/organization.services";
import FormSelectionField from "../../components/formFields/FormSelectionField";
// import { getAllActiveCities } from "../city/services/city.services";
// import { getAllActiveStates } from "../state/services/state.services";
// import { ICity } from "../city/cityModel";
// import { IState } from "../state/stateModel";
import FormDatePicker from "../../components/formFields/FormDateField";
import FormTextArea from "../../components/formFields/FormTextArea";
import FormNumericTextField from "../../components/formFields/FormNumericTextField";
import {
  filterBy,
  CompositeFilterDescriptor,
} from "@progress/kendo-data-query";
import {
  Grid as KendoGrid,
  GridColumn as Column,
  GridCustomCellProps,
  GridCustomHeaderCellProps,
  GridFilterChangeEvent,
  GridPageChangeEvent,
} from "@progress/kendo-react-grid";
import {
  HeaderThElement,
  PagerTargetEvent,
} from "@progress/kendo-react-data-tools";
import AlertBox from "../../components/common/AlertBox";
import ButtonEdit from "../../components/drawer/ButtonEdit";
import moment from "moment";
import { formatIndianNumber } from "../../_helper/helper";
import { PAYMENTTYPES } from "../../_contstants/common";
import ButtonCreate from "../../components/drawer/ButtonCreate";
import { useLocation, useNavigate } from "react-router-dom";
import { clearOrganizationDetail } from "./organizationSlice";

const CreateOrganization: React.FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const gridRef = useRef<any>(null);
  const location = useLocation();
  const OrganizationID = location.state?.OrganizationID;
  const OrganizationDetail = useAppSelector(
    (state) => state.organization.OrganizationDetail,
  );
  const loading = useAppSelector((state) => state.organization.loading);
  // const CityList = useAppSelector((state) => state.city.CityList);
  // const StateList = useAppSelector((state) => state.state.StateList);
  const [formKey, setFormKey] = React.useState(1);

  useEffect(() => {
    if (OrganizationID) {
      dispatch(getCompanyDetails(OrganizationID));
      dispatch(getRenewHistory(OrganizationID));
    }
  }, [OrganizationID]);

  useEffect(() => {
    setFormKey(formKey + 1);
  }, [OrganizationDetail]);

  useEffect(() => {
    // dispatch(getAllActiveCities());
    // dispatch(getAllActiveStates());

    return () => {
      dispatch(clearOrganizationDetail());
    };
  }, []);

  const handleSubmit = async (values: any) => {
    try {
      const insertPayload = {
        OrganizationID: OrganizationID,
        RegistrationDate: values.RegistrationDate
          ? moment(values.RegistrationDate).format("YYYY-MM-DD")
          : "",
        CompanyName: values.CompanyName ? values.CompanyName : "",
        GSTNo: values.GSTNo ? values.GSTNo : "",
        Address: values.Address ? values.Address : "",
        City: values.City ? values.City : "",
        State: values.State ? values.State : "",
        ContactPerson: values.ContactPerson ? values.ContactPerson : "",
        EmailID: values.EmailID ? values.EmailID : "",
        MobileNo: values.MobileNo ? values.MobileNo : "",
        TotalUser: values.TotalUser ? values.TotalUser : null,
        PaymentType: values.PaymentType ? values.PaymentType : "",
        Amount: values.Amount ? values.Amount : null,
        ExpiryDate: values.ExpiryDate
          ? moment(values.ExpiryDate).format("YYYY-MM-DD")
          : "",
      };
      const response = await dispatch(insertCompanyInfo(insertPayload));
      if (response?.meta?.requestStatus === "fulfilled") {
        dispatch(clearOrganizationDetail());
        navigate("/organization");
        // if (OrganizationID) {
        //   dispatch(getCompanyDetails(OrganizationID));
        // }
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      throw error;
    }
  };

  return (
    <>
      {loading && <LoadingPanel gridRef={gridRef} />}
      <div>
        <Form
          key={formKey}
          onSubmit={handleSubmit}
          initialValues={OrganizationDetail}
          render={(formRenderProps: FormRenderProps) => (
            <FormElement>
              <ShadowCard style={{ padding: 12 }}>
                <GridLayout
                  style={{ marginRight: 20 }}
                  gap={{ rows: 5, cols: 10 }}
                  cols={[
                    { width: "33.33%" },
                    { width: "33.33%" },
                    { width: "33.33%" },
                  ]}
                >
                  <GridLayoutItem colSpan={3}>
                    <Typography.h4 className="m-0">
                      {"Company Information"}
                    </Typography.h4>
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      name={`RegistrationDate`}
                      label="Registration Date"
                      format="dd/MM/yyyy"
                      component={FormDatePicker}
                      validator={requiredValidator}
                      astrike={true}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      name="CompanyName"
                      astrike={true}
                      label="Company Name"
                      placeholder="Company Name"
                      component={FormTextField}
                      validator={requiredValidator}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      name="GSTNo"
                      label="GST No"
                      // astrike={true}
                      placeholder="GST No"
                      component={FormTextField}
                      validator={gstWOValueValidator}
                      maxLength="15"
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      name="ContactPerson"
                      astrike={true}
                      label="Contact Person"
                      placeholder="Contact Person"
                      component={FormTextField}
                      validator={requiredValidator}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      name="EmailID"
                      label="Email ID"
                      astrike={true}
                      placeholder="i.e. example@gmail.com"
                      component={FormTextField}
                      validator={requiredValidator}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      name="MobileNo"
                      label="Mobile No"
                      type="number"
                      max={10}
                      placeholder="i.e. 9999999999"
                      component={FormTextField}
                      validator={MobileNoValidator}
                      astrike={true}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      name="Address"
                      label="Address"
                      placeholder="Address"
                      component={FormTextArea}
                      rows={2}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      name="City"
                      label="City"
                      placeholder="City"
                      component={FormTextField}
                      validator={requiredValidator}
                      astrike={true}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      name="State"
                      label="State"
                      placeholder="State"
                      component={FormTextField}
                    />
                  </GridLayoutItem>
                  {/* <GridLayoutItem>
                    <Field
                      id={"CityID"}
                      name={"CityID"}
                      astrike={true}
                      label={"City"}
                      placeholder="i.e. Ahmedabad"
                      component={FormSelectionField}
                      validator={requiredValidator}
                      options={CityList?.map((city: ICity) => {
                        return {
                          value: city?.ID,
                          label: city?.CityName,
                        };
                      })}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      id={"StateID"}
                      name={"StateID"}
                      label={"State"}
                      placeholder="i.e. Gujarat"
                      component={FormSelectionField}
                      // disabled={true}
                      options={StateList?.map((state: IState) => {
                        return {
                          value: state?.ID,
                          label: state?.StateName,
                        };
                      })}
                    />
                  </GridLayoutItem> */}
                </GridLayout>
              </ShadowCard>
              <ShadowCard style={{ padding: 12, marginTop: 20 }}>
                <GridLayout
                  style={{ marginRight: 20 }}
                  gap={{ rows: 5, cols: 10 }}
                  cols={[
                    { width: "33.33%" },
                    { width: "33.33%" },
                    { width: "33.33%" },
                  ]}
                >
                  <GridLayoutItem colSpan={3}>
                    <Typography.h4 className="m-0">
                      {"Subscription Details"}
                    </Typography.h4>
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      name="TotalUser"
                      astrike={true}
                      label="Total User"
                      placeholder="Total User"
                      component={FormNumericTextField}
                      validator={requiredValidator}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      id={"PaymentType"}
                      name={"PaymentType"}
                      astrike={true}
                      label={"Payment Type"}
                      placeholder="i.e. Yearly"
                      onChange={(e) => {
                        const selectedValue = e?.value;
                        const registrationDate = formRenderProps.valueGetter(
                          "RegistrationDate",
                        )
                          ? moment(
                              formRenderProps.valueGetter("RegistrationDate"),
                            )
                          : moment();

                        switch (selectedValue) {
                          case "Yearly":
                            formRenderProps.onChange("ExpiryDate", {
                              value: registrationDate
                                ?.clone()
                                ?.add(1, "year")
                                ?.subtract(1, "day")
                                ?.toDate(),
                            });
                            break;

                          case "Half Yearly":
                            formRenderProps.onChange("ExpiryDate", {
                              value: registrationDate
                                ?.clone()
                                ?.add(6, "months")
                                ?.subtract(1, "day")
                                ?.toDate(),
                            });
                            break;

                          case "Quarterly":
                            formRenderProps.onChange("ExpiryDate", {
                              value: registrationDate
                                ?.clone()
                                ?.add(3, "months")
                                ?.subtract(1, "day")
                                ?.toDate(),
                            });
                            break;

                          case "Monthly":
                            formRenderProps.onChange("ExpiryDate", {
                              value: registrationDate
                                ?.clone()
                                ?.add(1, "month")
                                ?.subtract(1, "day")
                                ?.toDate(),
                            });
                            break;

                          default:
                            console.log("Unknown payment type selected");
                        }
                      }}
                      component={FormSelectionField}
                      validator={requiredValidator}
                      options={PAYMENTTYPES?.map((type: any) => {
                        return {
                          value: type?.value,
                          label: type?.label,
                        };
                      })}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      name="Amount"
                      astrike={true}
                      label="Amount"
                      placeholder="Amount"
                      component={FormNumericTextField}
                      validator={requiredValidator}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      name={`ExpiryDate`}
                      label="Expiry Date"
                      format="dd/MM/yyyy"
                      // disabled
                      component={FormDatePicker}
                      validator={requiredValidator}
                      astrike={true}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem
                    colSpan={2}
                    style={{
                      marginTop: "20px",
                      display: "flex",
                      justifyContent: "end",
                      alignItems: "end",
                    }}
                  >
                    <div>
                      <ButtonWithLoading
                        label={"Save"}
                        type="submit"
                        disabled={!formRenderProps.allowSubmit || loading}
                        loading={loading}
                      />
                      <Button
                        type="button"
                        fillMode={"outline"}
                        themeColor={"primary"}
                        style={{ marginLeft: 10 }}
                        onClick={() => {
                          dispatch(clearOrganizationDetail());
                          navigate("/organization");
                        }}
                      >
                        Cancel
                      </Button>
                    </div>
                  </GridLayoutItem>
                </GridLayout>
              </ShadowCard>
            </FormElement>
          )}
        />
        <RenewHistoryGridComponent />
      </div>
    </>
  );
};

interface PageState {
  skip: number;
  take: number;
}

const initialDataState: PageState = { skip: 0, take: 10 };

const RenewHistoryGridComponent: React.FC = () => {
  const OrganizationList = useAppSelector(
    (state) => state.organization.OrganizationList,
  );

  const [filter, setFilter] = React.useState<
    CompositeFilterDescriptor | undefined
  >(undefined);
  const [page, setPage] = React.useState<PageState>(initialDataState);
  const [pageSizeValue, setPageSizeValue] = React.useState<
    number | string | undefined
  >();

  const pageChange = (event: GridPageChangeEvent) => {
    const targetEvent = event.targetEvent as PagerTargetEvent;
    const take =
      targetEvent.value === "All" ? OrganizationList.length : event.page.take;

    if (targetEvent.value) {
      setPageSizeValue(targetEvent.value);
    }
    setPage({
      ...event.page,
      take,
    });
  };

  const MyEditCommandCell = (props: any) => {
    // const handleOpenDeleteDialog = (ID: number) => {
    //   dispatch(openDialog("deleteCountry"));
    // };

    return (
      <td
        className="action-td"
        style={{
          ...props.style,
        }}
      >
        <ButtonEdit
          ID={props.dataItem.ID}
          drawerName="renewForm"
          tooltipTitle="Edit"
        />
        {/* <IconButton
          type="button"
          fillMode="flat"
          size="small"
          title="Delete"
          className="color-red"
          onClick={() => handleOpenDeleteDialog(props.dataItem.ID)}
          icon={MdDelete}
          iconClassName="absolute-position"
          iconStyle={{ fontSize: "24px" }}
        /> */}
      </td>
    );
  };

  const handleFilterChange = (e: GridFilterChangeEvent) => {
    setFilter(e.filter);
    setPage({ skip: 0, take: page.take });
  };
  const HeaderCustomCell = (props: GridCustomHeaderCellProps) => (
    <HeaderThElement
      columnId={props.thProps?.columnId || ""}
      {...props.thProps}
      className={`${props.thProps?.className || ""} table-header`}
    >
      {props.children}
    </HeaderThElement>
  );

  const CustomCell = (props: any) => {
    return (
      <td
        {...props.tdProps}
        colSpan={1}
        className={`${props.tdProps?.className || ""} table-cell`}
      >
        {props.children}
      </td>
    );
  };

  const MyDataCustomCell = (props: GridCustomCellProps) => (
    <CustomCell {...props} />
  );

  return (
    <>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginTop: "20px",
        }}
      >
        <Typography.h4 className="m-0">{"History"}</Typography.h4>
        <ButtonCreate label="Renew" drawerName="renewForm" />
      </div>
      {OrganizationList && OrganizationList.length ? (
        <KendoGrid
          style={{ maxHeight: "calc(100vh - 152px)", marginTop: 5 }}
          filterable={true}
          filter={filter}
          data={
            filter
              ? filterBy(OrganizationList, filter).slice(
                  page.skip,
                  page.take + page.skip,
                )
              : OrganizationList.slice(page.skip, page.take + page.skip)
          }
          onFilterChange={handleFilterChange}
          skip={page.skip}
          take={page.take}
          total={OrganizationList.length}
          pageable={{
            buttonCount: 5,
            pageSizes: [5, 10, 15, "All"],
            pageSizeValue: pageSizeValue,
            type: "input",
          }}
          onPageChange={pageChange}
          cells={{
            headerCell: HeaderCustomCell,
            data: MyDataCustomCell,
          }}
        >
          <Column
            field="Date"
            title="Date"
            cells={{
              data: (props) => {
                return (
                  <td {...props.tdProps} colSpan={1} className={"table-cell"}>
                    {moment(props.dataItem.Date).format("DD/MM/YYYY")}
                  </td>
                );
              },
            }}
          />
          <Column
            field="TotalUser"
            title="Total User"
            cells={{
              data: (props) => {
                return (
                  <td
                    {...props.tdProps}
                    colSpan={1}
                    className={"table-cell text-center fw-bold"}
                  >
                    {props.dataItem.TotalUser}
                  </td>
                );
              },
            }}
          />
          <Column
            field="Amount"
            title="Payment Amount"
            cells={{
              data: (props) => {
                return (
                  <td
                    {...props.tdProps}
                    colSpan={1}
                    className={"table-cell text-end fw-bold"}
                  >
                    {formatIndianNumber(props.dataItem.Amount)}
                  </td>
                );
              },
            }}
          />
          <Column
            field="PaymentType"
            title="Payment Type"
            cells={{
              data: (props) => {
                return (
                  <td
                    {...props.tdProps}
                    colSpan={1}
                    className={"table-cell text-center"}
                  >
                    {props.dataItem.PaymentType}
                  </td>
                );
              },
            }}
          />
          <Column
            field="ID"
            title="Actions"
            cells={{ data: MyEditCommandCell }}
            width={"110px"}
            filterable={false}
          />
        </KendoGrid>
      ) : (
        <AlertBox />
      )}
    </>
  );
};

export default CreateOrganization;
